@if (content) {
<div class="wrap flex flex-justify-between p-t-6 p-t-3-s p-t-3-m">
    <breadcrumbs class="block no-scrollbar overflow-auto"
                 [variant]="'light'"></breadcrumbs>
    <p *ifSize="'XL'"
       class="c1 col-12">{{'Product Code: %' | translate : product?.data?.sku}}</p>
</div>
<div class="wrap-x wrap-l m-t-2 m-t-3-s m-t-3-m">

    <!-- top section -->
    <!-- `.flex` class is required for `stickyPanel` -->
    <div class="pos-relative"
         [class]="isGoogleShoppingLayout ? client.sizeId > 1 ? 'bg-col-w p-r-20 p-l-20 p-t-5 p-b-5 b-radius-4' : 'bg-col-w' : ''"
         sizeClass="XL:flex">
        <div class="c-6 c-12-m c-12-s m-b-0"
             [class.m-r-4]="isGoogleShoppingLayout"
             [style.max-width]="isGoogleShoppingLayout && client.sizeId > 1 ? '524px' : 'unset'"
             [style.min-width]="isGoogleShoppingLayout && client.sizeId > 1 ? '524px' : 'unset'">
            <div *ifSize="'SM'"
                 class="bg-col-w p-a p-b-0">
                @if (isGoogleShoppingLayout) {
                <div class="_googleShoppingMobileTop">
                    <product-view-media class="_googleShoppingMobileMedia block"
                                        [source]="product"></product-view-media>
                    <div class="_googleShoppingMobileSummary">
                        <h1 class="s1">{{ product.data?.name }}</h1>
                        <p class="c2 col-12">{{'Product Code: %' | translate : product?.data?.sku}}
                        </p>
                        <product-view-price [small]="true"
                                            [hidePaypalPayInThree]="true" />

                        <reviews-io-rating class="_googleShoppingMobileReviews block c2"
                                           [theme]="'gold'"
                                           [biggerStars]="client.sizeId > 1"
                                           [product]="product"></reviews-io-rating>
                    </div>
                </div>
                } @else {
                <div [ngClass]="!productSpecificOutlet.content?.components?.length && !client.isCms && 'no'">
                    <div class="m-b b-radius-4 overflow-hidden">
                        <!-- product specific components -->
                        <icms-outlet-block #productSpecificOutlet
                                           [name]="'product-details-component'"
                                           [variant]="'product-details-component-' + product.data?.filter_brand"></icms-outlet-block>
                    </div>
                </div>

                <h1 class="h2">{{ product.data?.name }}</h1>

                <!-- reviews -->
                <reviews-io-rating class="m-t-2 block"
                                   [theme]="'gold'"
                                   [class]="client.sizeId > 1 ? 'p3' : 'c2'"
                                   [biggerStars]="true"
                                   [product]="product"></reviews-io-rating>

                <p class="c1 col-12 m-t-2">{{'Product Code: %' | translate : product?.data?.sku}}</p>
                }
            </div>

            <!-- media -->
            @if (!isGoogleShoppingLayout || client.sizeId > 1) {
            <product-view-media class="w-12 block bg-col-w"
                                [class]="isGoogleShoppingLayout ? 'm-t-2 p-a-3' : 'p-a'"
                                [source]="product"></product-view-media>
            }

            <product-view-details *ifSize="'SM'"
                                  class="w-12 block p-a p-t-0-s bg-col-w"
                                  [product]="product"
                                  [googleShoppingLayout]="isGoogleShoppingLayout">
            </product-view-details>


            @if(!isGoogleShoppingLayout) {
            <simple-related-products class="block p-a bg-col-w b-radius-4-x b-radius-4-l m-t m-t-8-s m-t-8-m"
                                     [title]="'Frequently bought together'"
                                     [source]="product"
                                     [limit]="16"
                                     [options]="{
                                        engines:[{id: 'crosssell',
                                        }]}"></simple-related-products>
            @if(product.data?.description) {
            <div class="p-a bg-col-w b-radius-4-x b-radius-4-l m-t">
                <p class="s1">{{'Description' | translate}}</p>
                <read-more class="col-1 m-t-2 block p2"
                           [limit]="['210','225','225','225'][client.sizeId]"
                           [text]="product.data.description">
                </read-more>
            </div>
            }

            @if(product.data?.features_block) {
            <div class="p-a bg-col-w b-radius-4-x b-radius-4-l m-t">
                <p class="s1">{{'Features' | translate}}</p>
                <div class="m-t-2 p2 _features"
                     [innerHTML]="product.data?.features_block"></div>
            </div>
            }


            @if(specificationsAttr?.length) {
            <div class="p-a bg-col-w b-radius-4-x b-radius-4-l m-t">
                <p class="s1">{{'Specifications' | translate}}</p>
                <product-view-specification class="block m-t"
                                            [product]="product"
                                            [attrs]="specificationsAttr"></product-view-specification>
            </div>
            }

            @if(product.data?.attachments) {
            <div class="p-a bg-col-w b-radius-4-x b-radius-4-l m-t">
                <p class="s1 m-b">{{'Data sheets' | translate}}</p>
                <div [grid]="client.sizeId > 0 ? 2 : 1"
                     [gridRowGap]="'6px'">
                    @for(attachment of product.data?.attachments; track attachment){
                    <div class="flex">
                        <i class="icon-file inline-flex m-r"
                           aria-hidden="true"></i>
                        <href class="block link m-b-2 left"
                              [link]="attachment?.path"
                              [hrefTarget]="_blank">
                            <span sizeClass="XL:p2, SM:p1">{{attachment?.labels?.[0] || attachment?.filename}}</span>
                        </href>
                    </div>
                    }
                </div>
            </div>
            }
            }

        </div>

        <!-- details -->
        <div *ifSize="'XL'"
             class="c-12-m c-12-s m-r-0 m-b-0 pos-relative"
             [class]="isGoogleShoppingLayout ? 'flex-grow' : 'c-6'">

            <div [stickyPanel]="client.sizeId > 1"
                 [stickyPanelOffsetTop]="150">
                <div [class]="!productSpecificOutlet.content?.components?.length && !client.isCms ? 'no' : ''">
                    <div class="b-radius-4 overflow-hidden m-b">
                        <!-- product specific components -->
                        <icms-outlet-block #productSpecificOutlet
                                           [name]="'product-details-component'"
                                           [variant]="'product-details-component-' + product.data?.filter_brand"></icms-outlet-block>
                    </div>
                </div>
                <div class="p-a bg-col-w b-radius-4">
                    <product-view-details [product]="product"
                                          [googleShoppingLayout]="isGoogleShoppingLayout"
                                          (viewFullDescription)="exitGoogleShoppingLayout()">
                    </product-view-details>
                </div>
            </div>
        </div>
    </div>
</div>
}
@if (content && isGoogleShoppingLayout) {
@if (isGoogleShoppingCategoryLoading) {
<div class="wrap flex flex-justify-center p-t-8 p-b-8">
    <loader></loader>
</div>
} @else if (vatListingCategory && vatListing) {
<cms-category-header-block #categoryHeader
                           [variant]="vatListingCategory.categoryHeaderVariant"
                           [categoryName]="vatListingCategory.data!.name"
                           [categoryImage]="vatListingCategory.data!.image"
                           [categoryDescription]="vatListingCategory.data!.description"
                           [hideBreadcrumb]="true"
                           class="block m-t-10 m-t-4-s m-t-6-m"></cms-category-header-block>
<div class="bg-col-51">
    <product-listing class="block p-b-8 p-t-5 p-t-0-s p-t-0-m"
                     [category]="vatListingCategory"
                     [listing]="vatListing"></product-listing>
</div>
}
}
@if (content && !isGoogleShoppingLayout) {
<div class="m-t-8">
    <!-- product specific components -->
    <icms-outlet-block [name]="'product-specific-component'"
                       [variant]="'product-specific-component-' + product.data?.filter_brand"></icms-outlet-block>

    <!-- bottom components -->
    <icms-outlet [components]="content.bottomComponents"
                 [allow]="['product-reviews', 'related-products', 'quick-links']"></icms-outlet>

    <!-- reviews -->
    <reviews-io-polaris [product]="product"></reviews-io-polaris>
</div>
}
<!-- zoom in lightbox -->
<photoswipe-lightbox [photoswipeOptions]="photoswipeOptions"
                     (photoswipeStateChange)="onPhotoswipeStateChange($event)"
                     (photoswipeChanged)="onPhotoswipeChanged($event)">
    <ng-template #photoswipeThumbnailTpl
                 let-item
                 let-index="index"
                 let-photoswipe="photoswipe">
        @if (item.source) {
        <div class="pos-relative bg-col-5 pswp__thumb b-radius-4"
             [class.is-active]="item === photoswipe?.currItem"
             (click)="photoswipe?.goTo(index)">
            <div class="fill overflow-hidden"
                 [class._hasVideoZoom]="item.onFocusOnly">
                <img [fill]="true"
                     [ratio]="1"
                     [dfImage]="item.source"
                     [attr.alt]="source?.data?.name || ''">
            </div>
            @if (item.onFocusOnly) {
            <i class="icon-play pos-absolute top-50 left-50 col-w icon-medium"
               style="transform: translate(-50%, -50%)"></i>
            }
        </div>
        }
    </ng-template>

    <ng-template #photoswipeIconCloseTpl>
        <i class="icon-arrow-left inline-flex va-m"
           aria-hidden="true"></i>
        <span class="inline-flex overflow-hidden no-wrap">&nbsp;&nbsp;{{'Back to item' | translate}}</span>
    </ng-template>

    <ng-template #photoswipeIconPrevTpl></ng-template>

    <ng-template #photoswipeIconNextTpl></ng-template>
</photoswipe-lightbox>
